export enum AuthenticationActionsTypes {
    USER_SIGN_IN = "USER_SIGN_IN",
    USER_SIGN_OUT = "USER_SIGN_OUT",
}


export default AuthenticationActionsTypes;
